import type { PortalViewOutput } from '@garage/shared';
import { formatDateTime } from '../../garage/lib/format.js';
import { usePortalPreview } from '../preview.js';
import { PortalEntryReport } from './PortalEntryReport.js';
import { Block, CARD } from './portal-ui.js';

function NoReport() {
  return (
    <Block title="Fiche de réception">
      <p className={`${CARD} text-ink-2`}>Le garage n’a pas encore partagé de fiche de réception pour ce véhicule.</p>
    </Block>
  );
}

/**
 * Onglet Réception : fiche de réception signée (résumé `reception` de la vue ; contenu par `portal.entryReport`,
 * PDF par `portal.entryReportPdf`, prise de connaissance si prévue). Aperçu côté garage : résumé seul, sans jeton.
 */
export function ReceptionTab({ view }: { view: PortalViewOutput }) {
  const preview = usePortalPreview() !== null;
  const r = view.reception;
  if (r === null) return <NoReport />;
  if (preview) {
    if (!r) return <NoReport />;
    const tz = view.intervention.timezone;
    return (
      <Block title="Fiche de réception">
        <div className={`${CARD} space-y-2`}>
          <p className="text-ink">
            Fiche n° {r.number}
            {r.version > 1 ? `, version ${r.version}` : ''} · établie le {formatDateTime(r.validatedAt, tz)}
            {r.signed ? ' · signée à l’accueil' : ''}
          </p>
          {r.acknowledgment ? (
            <p className="text-sm text-ink-2">
              {r.acknowledgment.channel === 'in_person' ? 'Signée au garage' : 'Le client en a pris connaissance'} le {formatDateTime(r.acknowledgment.at, tz)}.
            </p>
          ) : r.acknowledgeable ? (
            <p className="text-sm text-ink-2">Le client peut indiquer en avoir pris connaissance.</p>
          ) : null}
          <p className="text-sm text-ink-3">Le client consulte la fiche complète{r.pdfAvailable ? ' et télécharge son PDF' : ''} dans cet onglet.</p>
        </div>
      </Block>
    );
  }
  return <PortalEntryReport readOnly={view.mode === 'report'} signed={r?.signed ?? false} empty={<NoReport />} />;
}
